export const amountPassenger = [
  {
    value: '1',
    label: '1',
  },
  {
    value: '2',
    label: '2',
  },
  {
    value: '3',
    label: '3',
  },
  {
    value: '4',
    label: '4',
  },
  {
    value: '5',
    label: '5',
  },
  {
    value: '6',
    label: '6',
  },
];

export const vehicle_type = [
  {
    value: 'sedan',
    label: 'sedán',
  },
  {
    value: 'minibus',
    label: 'micro-bus',
  },
  {
    value: 'bus',
    label: 'bus',
  },
  {
    value: 'off_road',
    label: 'todo terreno',
  },
];

export const vehicle_status = [
  {
    value: 'out_of_service',
    label: 'Fuera de servicio',
  },
  {
    value: 'available',
    label: 'Disponible',
  },
];

export const travel_type = {
  'roundtrip': 'Ida y vuelta',
  'one_way': 'Solo ida',
  'multi_places': 'Multidestino'
}
